import BaseMediaResource from './BaseMediaResource'

class VideoResource extends BaseMediaResource {
  get vimeoVideoUrl() {
    return this.resourceUrl
  }
}
export default VideoResource
